import React from 'react';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';

export const GraphLegend = ({
  children,
  color,
}: {
  children: React.ReactNode;
  color: string;
}) => {
  return (
    <Spacing direction="horizontal" size="sm" className="items-center w-fit">
      <div
        className="w-5 h-3 rounded-sm"
        style={{ backgroundColor: color }}
      ></div>
      <p className="font-sans text-sm">{children}</p>
    </Spacing>
  );
};
